<template>
    <div class="row">
        <div class="data-container w-100">
            <b-table show-empty
                :empty-text="(loading) ? 'Loading data' : 'No data to show'"
                :items="histories"
                :fields="customersTransactionFields"
                responsive>
                <template slot="date" slot-scope="data">
                    {{ data.item.transaction_date + ' ' + data.item.transaction_time }}
                </template>
                <template slot="action" slot-scope="data">
                    <template v-if="data.item.transaction_status_type == 'redeem-reward' || data.item.transaction_status_type == 'issue-reward' || data.item.transaction_status_type == 'give' || data.item.transaction_status_type == 'earn' || data.item.transaction_status_type == 'transfer-points'">
                        <b-button
                            :disabled="!!data.item.is_void"
                            variant="secondary btn-table-void"
                            @click="voidDeduction(data.item, data.item.transaction_status_type)">
                            X Void
                        </b-button>
                    </template>
                </template>
            </b-table>
        </div>
        <div class="w-100 px-3">
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">Showing {{ currentFirstItem }} to {{ currentLastItem }} of {{ maxPage}} pages</span>
                    </div>
                </b-col>
                <b-col>
                    <b-pagination
                        hide-goto-end-buttons
                        align="right"
                        size="md"
                        :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                        :limit="(totalPerPage > 0 ) ? 5 : 1"
                        :per-page="totalPerPage"
                        @change="paginate"
                        class="custom-pagination">
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";

// const customersTransaction = [
//     {
//         date: "Aug 3, 2018 1:30 PM",
//         transaction_no: "0000001",
//         activity:
//             "Achievement unlocked! Earned 50 points for connecting with Facebook",
//         employee_id: "23424-74"
//     }
// ];
const transactionHistoryFilter = [
    {
        value: 0,
        text: "All Transactions"
    }
];

export default {
    name: "transaction-history-tab",
    props: ["uuid"],
    components: {
        Datepicker
    },
    data() {
        return {
            filter: {
                keyword: null,
                field: null,
                dateFrom: null,
                dateTo: null
            },
            searchFields: [
                {
                    key: "firstname",
                    label: "First Name"
                },
                {
                    key: "lastname",
                    label: "Last Name"
                },
                {
                    key: "email",
                    label: "Email"
                },
                {
                    key: "mobile_number",
                    label: "Mobile Number"
                },
                {
                    key: "registration_channel",
                    label: "Registration Channel"
                }
            ],
            singleDateConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d"
            },
            customersTransactionFields: [
                {
                    key: "created_at",
                    label: "Date"
                },
                {
                    key: "details",
                    label: "Transaction No"
                },
                {
                    key: "message",
                    label: "Activity"
                },
                {
                    key: "action"
                }
            ],
            transactionHistoryFilter: transactionHistoryFilter,
            selectedFilter: 0,
            importCsv: null
        };
    },
    computed: {
        ...mapState("transactions", [
            "histories",
            "loading",
            "view",
            "list",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "message",
            "customer",
            "currentFirstItem",
            "currentLastItem",
            "currentPage",
            "totalPerPage"
        ]),
        filterKeyword() {
            return this.filter.keyword;
        },
        filterField() {
            return this.filter.field;
        },
        filterDateFrom() {
            return this.filter.dateFrom;
        },
        filterDateTo() {
            return this.filter.dateTo;
        },
        daterangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        _this.selectedDate(selectedDates);
                    }
                };
            }
        }
    },
    created: function() {
        this.getCustomerHistory(1);
    },
    methods: {
        getCustomerHistory(page = 1) {
            let param = {
                apiFields: {
                    customer_uuid: [this.uuid],
                    page: page
                }
            };

            this.$store.dispatch("transactions/getCustomerHistory", param);
        },
        selectedDate(value) {
            let range = {};
            if (value.length == 2) {
                range = {
                    start: this.$moment(value[0]).format("YYYY-MM-DD"),
                    end: this.$moment(value[1]).format("YYYY-MM-DD")
                };

                this.filterDate(range, this.currentPage);
            }
        },
        filterDate(range, page = 1) {
            let param = {
                apiFields: range,
                page: page
            };

            this.$store.dispatch("transactions/filterByDate", param);
        },
        paginate(page) {
            console.log(page);
            if (this.searching) {
                return this.search(false, page);
            }
            return this.getCustomerHistory(page);
        },
        async voidDeduction(item, transactionStatusType) {
            let param = {
                customer_uuid: item.customer_uuid,
                action: item.transaction_status_type,
                reference: JSON.stringify({
                    transaction_no: item.details,
                    transaction_uuid: item.transaction_uuid,
                })
            };
            // await this.$store.commit("points/setVoidDetails", item);
            await this.$store.dispatch("points/voidDeduction", param).then(() => {
                this.getCustomerHistory(1);
            });
        }
    },
    watch: {
        uuid: function() {
            this.getCustomerHistory(1);
        }
    }
};
</script>
